import React from "react";
import { Tag } from "antd";
import { SourcingStatus, SourcingType, InvitationMode } from "../interface";

export const StatusBadge: React.FC<{ status: SourcingStatus }> = ({ status }) => {
  const colorMap: Record<SourcingStatus, string> = {
    DRAFT: "default",
    SUBMITTED: "processing",
    APPROVED: "success",
    PUBLISHED: "purple",
    CLOSED: "orange",
    REJECTED: "error",
    RESULT_SUBMITTED: "cyan",
    AWARD_APPROVED: "blue",
    PARTIALLY_AWARDED: "geekblue",
    AWARDED: "gold",
  };
  return <Tag color={colorMap[status] || "default"}>{status}</Tag>;
};

export const TypeBadge: React.FC<{ type: SourcingType }> = ({ type }) => {
  const colorMap: Record<SourcingType, string> = {
    RFQ: "blue",
    RFP: "purple",
  };
  return <Tag color={colorMap[type] || "default"}>{type}</Tag>;
};

export const ModeBadge: React.FC<{ mode: InvitationMode }> = ({ mode }) => {
  const colorMap: Record<InvitationMode, string> = {
    CLOSED: "orange",
    OPEN: "green",
  };
  return <Tag color={colorMap[mode] || "default"}>{mode}</Tag>;
};